import {createMuiTheme} from 'material-ui/styles';
export const overrideTheme = createMuiTheme({
    overrides: {
        SelectMenuOuter: {
            position: 'relative !important',
        }
    }
});

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    rootGrid: {
        flexGrow: 1,
    },
    table: {
        minWidth: 700,
        overflowX: 'auto',
    },
    rootStaffTable: {
        width: '100%',
        marginTop: 0,
        overflowX: 'auto',
    },
    tableCell: {
        padding: '4px 15px 4px 20px',
        cursor: 'default'
    },
    tableCellCenter: {
        textAlign: 'center',
        padding: '4px 15px 4px 20px',
    },
    tableIconBtn: {
        textAlign: 'center',
        padding: '5px 15px 5px 0',
    },
    headerLabels: {
        fontWeight: '700',
        fontSize: '0.9rem',
    },
    buttons: {
        padding: '15px 0 0 15px'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'row',
        width: '100%',
    },
    containerLineOne: {
        display: 'flex',
        flexDirection: 'row',
    },
    containerLineTwo: {
        display: 'block',
        flexDirection: 'row',
    },
    textField: {
        width: '100%',
    },
    filterButton: {
        marginLeft: 0,
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginBottom: theme.spacing.unit * 2,
    },
    selectMenuItemFilters: {
        fontSize: '14px',
        padding: '0 15px'
    },
    staffRows: {
        marginTop: 15
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    button: {
        margin: theme.spacing.unit,
    },
    dialogActionsBtn: {
        margin: '8px 28px'
    },
    imageEdit: {
        maxWidth: 500,
        margin: 'auto',
        display: 'flex'
    },
    imageViewStaff: {
        maxWidth: 500,
        display: 'flex'
    },
    staffImageField: {
       padding: 10,
    },
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    staffViewLead: {
        fontSize: '18px'
    },
    staffViewContent: {
        padding: '15px'
    },
    staffContentParagraph: {
        color: '#666',
        margin: '0',
        '& p': {
            margin: 0
        }
    },
});

export default styles;


// WEBPACK FOOTER //
// ./src/containers/staff/style/styles.js